import { mapActions } from 'vuex';

export default {
    methods: {
        ...mapActions('user', ['dismissTwoFactorPrompt', 'setNavigatingToTwoFactorSetup']),
        ...mapActions('popup', ['setCurrentPopup']),

        onSetupNow() {
            this.dismissTwoFactorPrompt();
            this.setCurrentPopup(null);
            // Set flag to prevent ADD_FUNDS from showing during navigation
            this.setNavigatingToTwoFactorSetup(true);
            this.$router.push({ name: 'account-settings' });
        },

        onNotNow() {
            this.dismissTwoFactorPrompt();
            this.setCurrentPopup(null);
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/account/account-two-factor-prompt/account-two-factor-prompt.js